export const idCreator = val => {
  const id =
    !val || !/\S/.test(val)
      ? `id${Math.floor(Math.random() * 1000)}`
      : val.replace(/\s+/g, "");

  return {
    labelId: `${id}-label`,
    inputId: `${id}-input`,
    listId: `${id}-list`,
    textAreaId: `${id}-textarea`,
    modernizedInputId: `${id}-modernized-input`,
    modernizedLabelId: `${id}-modernized-label`
  };
};
